import React from 'react';

import {Button, LoadingSpinner} from '@albert-io/atomic';
import {useStudentHomepageStore} from 'client/StudentHomepage/useStudentHomepageStore';

interface Props extends PropsWithClassNameOptional {
  inert?: boolean;
}

export default function JoinClassroomSubmitButton({className, inert = false}: Props) {
  const isError = useStudentHomepageStore((state) => state.isStudentEnrollmentError);
  const isRequestPending = useStudentHomepageStore((state) => state.isStudentEnrollmentPending);
  const value = useStudentHomepageStore((state) => state.classroomCode);

  return (
    <Button
      aria-label='Submit code'
      className={className}
      data-testid='join-code-form__submit'
      disabled={inert || isRequestPending || isError || value === ''}
      type='submit'
    >
      {isRequestPending && !inert ? (
        <LoadingSpinner bottomMarginLevel={0} className='px-x3' />
      ) : (
        'Join Class'
      )}
    </Button>
  );
}
